module.exports = __webpack_public_path__ + "img/mountain_autumn.0116fb77.jpg";